// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3uC2f","search":"Settings_search__1BapY","filter":"Settings_filter__TXagf"};